"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitConfig = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "getInitConfig", { enumerable: true, get: function () { return features_1.getInitConfig; } });
//# sourceMappingURL=index.js.map